import { render } from "./activity-detail.vue?vue&type=template&id=44d4908e"
import script from "./activity-detail.vue?vue&type=script&lang=js"
export * from "./activity-detail.vue?vue&type=script&lang=js"

import "./activity-detail.vue?vue&type=style&index=0&id=44d4908e&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__